import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import Menu from "../menu/Menu";
import InfoCotizaRepuestos from "../cotizarepuestos/InfoCotizaRepuestos";
const Footer = lazy(() => import('../footer/Footer'));
function Repuestos() {
  return (
    <Fragment>
      <Helmet>
        <meta
          name="description"
          content="Hyundai cuenta con una alta gama de repuestos originales. Cotiza el que tu necesites."
        />
        <meta
          name="keywords"
          content="Repuestos Hyundai, Repuesto, red de servicio, servicio Hyundai"
        />
        <title>Repuestos Hyundai</title>
      </Helmet>
      <Menu />
      <InfoCotizaRepuestos />
      <Suspense fallback={<div>Cargando footer...</div>}>
        <Footer />
      </Suspense>
    </Fragment>
  );
}
export default Repuestos;